import { useEffect, useState } from 'react'
import { ReportAPI } from '../apis/ReportAPI'
import {
  CandidateReport,
  CandidateReport2,
} from '../apis/entities/report.entity'
import 'reactflow/dist/base.css'
import '../components/charts/styles.css'
import { Assessment, Assessment2 } from '../apis/entities/assessment.entity'
import ReactLoading from 'react-loading'
import logo from '../images/unsw.jpg'
import ReportContent1 from './ReportContent1'
import ReportContent2 from './ReportContent2'
import ReportContent3 from './ReportContent3'
import { Assessment3 } from '../apis/entities/assessment.entity'
import { formatReportDate } from '../utils/dateUtils'

type AssessmentIndividualReportProps = {
  candidateId: string
}

// Common Footer component
export const Footer = () => {
  return (
    <div className="absolute top-[1097px] w-full">
      <div className="font-roboto flex items-center gap-2 justify-end border-t border-black pt-2">
        <span>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM8.89258 8.58887C10.5675 6.59294 13.3866 6.45808 15.21 8.2959C15.5988 8.68797 15.5961 9.32103 15.2041 9.70996C14.812 10.0988 14.179 10.0961 13.79 9.7041C12.7992 8.70562 11.3471 8.77503 10.4248 9.87402C9.43819 11.0497 9.43819 12.9503 10.4248 14.126C11.3471 15.225 12.7992 15.2944 13.79 14.2959C14.179 13.9039 14.812 13.9012 15.2041 14.29C15.5961 14.679 15.5988 15.312 15.21 15.7041C13.3866 17.5419 10.5675 17.4071 8.89258 15.4111C7.28244 13.492 7.28244 10.508 8.89258 8.58887Z"
              fill="black"
            />
          </svg>
        </span>
        2026 UNSW. All rights reserved.
      </div>
    </div>
  )
}

export default function AssessmentIndividualReport({
  candidateId,
}: AssessmentIndividualReportProps) {
  const [data, setData] = useState<CandidateReport | null | undefined>()
  const [data2, setData2] = useState<CandidateReport2 | null | undefined>()
  const [showAllOutcomes, setShowAllOutcomes] = useState(false)
  const [assessment, setAssessment] = useState<Assessment | null | undefined>(
    undefined,
  )
  const [assessment2, setAssessment2] = useState<
    Assessment2 | null | undefined
  >(undefined)
  const [data3, setData3] = useState<CandidateReport2 | null | undefined>()
  const [assessment3, setAssessment3] = useState<
    Assessment3 | null | undefined
  >(undefined)

  const fetchData = async () => {
    const fetchedAssessment = await ReportAPI.getAssessment(candidateId)
    console.log('fetchedAssessment', fetchedAssessment)

    if (fetchedAssessment?.version === 1) {
      setAssessment(fetchedAssessment)
      const reportData = await ReportAPI.fetchIndividualReport(candidateId)
      if (reportData) {
        console.log('data v1', reportData)
        setData(reportData)
      }
    } else if (fetchedAssessment?.version === 2) {
      setAssessment2(fetchedAssessment)
      const reportData = await ReportAPI.fetchIndividualReport2(candidateId)
      if (reportData) {
        console.log('data v2', reportData)
        setData2(reportData)
      }
    } else if (fetchedAssessment?.version === 3) {
      setAssessment3(fetchedAssessment)
      const reportData = await ReportAPI.fetchIndividualReport3(candidateId)
      if (reportData) {
        console.log('data v3', reportData)
        setData3(reportData)
      }
    }
  }

  useEffect(() => {
    fetchData()
      .catch(console.error)
      .finally(() => {})
  }, [])

  const testDate = data
    ? formatReportDate(data.submittedAt)
    : data2
    ? formatReportDate(data2.submittedAt)
    : data3
    ? formatReportDate(data3.submittedAt)
    : ''

  return (
    <>
      {!assessment && !assessment2 && !assessment3 && (
        <div className="flex grow relative w-screen h-screen overflow-auto">
          <ReactLoading
            className="fixed top-[50%] left-[50%]"
            type={'spinningBubbles'}
            color={'#eeeeee'}
            height={'64px'}
            width={'64px'}
          />
        </div>
      )}
      {assessment?.version === 1 && data && (
        <ReportContent1
          candidateId={candidateId}
          assessment={assessment}
          data={data}
          testDate={testDate}
          logo={logo}
          showAllOutcomes={showAllOutcomes}
        />
      )}
      {assessment2?.version === 2 && data2 && (
        <ReportContent2
          candidateId={candidateId}
          assessment={assessment2}
          data={data2}
          testDate={testDate}
          logo={logo}
          showAllOutcomes={showAllOutcomes}
        />
      )}
      {assessment3?.version === 3 && data3 && (
        <ReportContent3
          candidateId={candidateId}
          assessment={assessment3}
          data={data3 as any}
          testDate={testDate}
          logo={logo}
          showAllOutcomes={showAllOutcomes}
        />
      )}
    </>
  )
}
